module.exports = __webpack_public_path__ + "static/assets/b57d27c7c720b3080a14bce2a29b0236.svg";